import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment as ENV } from "environments/environment";

import { BehaviorSubject, Observable, of, Subject } from "rxjs";

import { CotizacionDTO } from "../../interfaces/cotizacion.interface";
import { PageCotizacionDTO } from "../../interfaces/page-cotizacion.interface";

import { CotizacionServicioDTO } from "../../models/cotizacion-servicio.model";

import { FiltrosService } from "../util/filtros.service";

const API = "cotizaciones/";

@Injectable({
    providedIn: "root",
})
export class CotizacionesService {
    private paginaActual: number;
    private cantidaResultadosPorPagina: number;
    private campoOrden: string;
    private orden: string;
    private totalDeResultados: number;
    private cantidadPaginas: number;
    public cotizacionesRefresh$: BehaviorSubject<boolean>;
    public onServicioCotizacionChanged$: Subject<CotizacionDTO> = new Subject();
    public onCotizacionChanged$: Subject<PageCotizacionDTO>;

    constructor(private http: HttpClient, private _filtros: FiltrosService) {
        this.onCotizacionChanged$ = new Subject();
        this.cotizacionesRefresh$ = new BehaviorSubject(null);
        this.resetPaginador();
    }

    resetPaginador() {
        this.paginaActual = 0;
        this.cantidaResultadosPorPagina = 10;
        this.totalDeResultados = 0;
        this.cantidadPaginas = 0;
        this.campoOrden = "fechaSolicitud";
        this.orden = "desc";
    }

    fetchServiciosCotizacion(idCotizacion: number): Observable<CotizacionDTO> {
        return this.http.get<CotizacionDTO>(
            `${ENV.apiUrl}${API}${idCotizacion}`
        );
    }

    fetchCotizaciones(): Observable<PageCotizacionDTO> {
        const filtrosCotizaciones = this._filtros.getFiltro(
            "filtrosCotizaciones"
        );
        //console.log("filtros", filtrosCotizaciones);

        let parametros: string = "";
        parametros +=
            filtrosCotizaciones.idCliente[0].valor > 0
                ? "&idCliente=" + filtrosCotizaciones.idCliente[0].valor
                : "";
        parametros +=
            filtrosCotizaciones.vigencia[0].valor > 0
                ? "&vigencia=" + filtrosCotizaciones.vigencia[0].valor
                : "";

        parametros +=
            filtrosCotizaciones.situacion[0].valor > 0
                ? "&situacion=" + filtrosCotizaciones.situacion[0].valor
                : "";

        return this.http.get<PageCotizacionDTO>(
            `${ENV.apiUrl}${API}?page=${this.paginaActual}&size=${this.cantidaResultadosPorPagina}${parametros}&sort=${this.campoOrden},${this.orden}`
        );
    }

    generaSolicitudCotizacion(
        //servicios: ServicioSolicitadoDTO[],
        //archivos: string[]
        formData: FormData
    ): Observable<any> {
        //file.inProgress = true;

        /*const req = new HttpRequest("POST", `${ENV.apiUrl}${API}`, formData, {
            reportProgress: true,
            responseType: "json",
        });

        return this.http.request(req);*/
        return this.http.post<any>(`${ENV.apiUrl}${API}`, formData, {
            reportProgress: true,
            //observe: "events",
        });
    }

    generaCotizacionServicio(
        cotizacionServicio: CotizacionServicioDTO
    ): Observable<any> {
        return this.http.post<any>(
            `${ENV.apiUrl}${API}servicio/`,
            cotizacionServicio
        );
    }

    rechazarCotizacionServicio(
        idCotizacionServicio: number,
        observacion: string
    ) {
        const requestOptions: Object = {
            responseType: "text",
        };
        return this.http.post<any>(
            `${ENV.apiUrl}${API}rechazar/${idCotizacionServicio}`,
            observacion,
            requestOptions
        );
    }

    solicitaActualizacion(idCotizacion: number): Observable<any> {
        return this.http.put<any>(
            `${ENV.apiUrl}${API}${idCotizacion}/renovar`,
            null
        );
    }
    actualizaVigenciaCotizacion(
        idCotizacion: number,
        fecha: string
    ): Observable<any> {
        return this.http.patch<any>(
            `${ENV.apiUrl}${API}${idCotizacion}?fecha=${fecha}`,
            null
        );
    }

    fetchArchivoCotizacion(
        idServicioSolicitudCotizacion: number
    ): Observable<Blob> {
        const requestOptions: Object = {
            responseType: "blob",
            reportProgress: true,
        };
        return this.http.get<any>(
            `${ENV.apiUrl}${API}servicio/${idServicioSolicitudCotizacion}/adjunto`,
            requestOptions
        );
    }

    setCampoOrden(campoOrden: string) {
        this.campoOrden = campoOrden;
    }

    getCampoOrden(): string {
        return this.campoOrden;
    }

    setCantidadPaginas(cantidadPaginas: number): void {
        this.cantidadPaginas = cantidadPaginas;
    }

    getCantidadPaginas(): number {
        return this.cantidadPaginas;
    }

    getTotalDeResultados(): number {
        return this.totalDeResultados;
    }

    setTotalDeResultados(totalDeResultados: number): void {
        this.totalDeResultados = totalDeResultados;
    }

    setOrden(orden: string): void {
        this.orden = orden;
    }

    getOrden(): string {
        return this.orden;
    }

    setPaginaActual(pagina: number): void {
        this.paginaActual = pagina;
    }

    getPaginaActual(): number {
        return this.paginaActual;
    }

    setCantidaResultadosPorPagina(cantidadResultados: number): void {
        this.cantidaResultadosPorPagina = cantidadResultados;
    }

    getCantidaResultadosPorPagina(): number {
        return this.cantidaResultadosPorPagina;
    }
}
